<!-- 

<div class=" " style="height: 64px; display: flex; justify-content: space-evenly; align-items: center; position: absolute; right: 24px;">
    <label class="mat-small" style="opacity: .6;">Ver como:</label>
        <button [class]="" mat-icon-button color="primary"
            (click)="calendarioActivo = false; listaActiva = true;">
            <mat-icon>calendar_today</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="calendarioActivo = false; listaActiva = true;">
            <mat-icon>view_list</mat-icon>
        </button>
</div>
<div *ngIf="calendarioActivo" style="max-height: calc(100vh - 152px); overflow: hidden;">
    <unidad-eventos-calendario [eventos]="_eventos" [fechaInicio]="fechaInicio" [fechaFin]="fechaFin"
        (eliminar)="eliminarEvento($event)" [areas]="areas"></unidad-eventos-calendario>
</div>
 -->

<div [hidden]="!listaActiva" class="eventos-container">
    <h3 class="mat-h2">Eventos de aprendizaje</h3>
    
    <!-- 
    <form [formGroup]="filterForm">
        <div class="tools">
            <div *ngIf="areas">
                <mat-form-field *ngIf="areas.length > 1" appearance="outline" class="full-width">
                    <mat-label>Filtrar materias</mat-label>
                    <mat-select formControlName="materias" multiple>
                        <mat-option *ngFor="let area of areas" [value]="area.id">{{area.nombre}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="toolx3">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Filtrar cursos</mat-label>
                    <mat-select formControlName="cursos" placeholder="Filtrar por grupo" [multiple]="true">
                        <mat-option *ngFor="let materia of materiasDisponibles" [value]="materia.id">
                            {{materia.nombreCompleto}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            
        </div>
    </form>
     -->
    <!-- 
    <div class="flex-wrap" style="padding-bottom: 8px;">
        <button mat-button (click)="filtroActivo = 'todos';mostrarRango()"
            [color]="filtroActivo == 'todos' ? 'primary':''">Todos</button>
        &nbsp;&nbsp;
        <button mat-button (click)="filtroActivo = 'semana';mostrarRango()"
            [color]="filtroActivo == 'semana' ? 'primary':''">Semana</button>
        &nbsp;&nbsp;
        <button mat-button (click)="filtroActivo = 'hoy';mostrarRango()" [color]="filtroActivo == 'hoy' ? 'primary':''">Hoy</button>
        <span class="spacer"></span>
        <mat-slide-toggle (change)="toggleEstadoResumen($event.checked)" #control>
            {{control.checked ? 'Contraer' : 'Expandir'}}</mat-slide-toggle>
    </div>
    -->

    <ng-container *ngFor="let evento of _eventos">
        <unidad-evento [eventoUnidad]="evento" (eliminar)="eliminarEvento($event)" [showResumenStatus]="resumenAbierto" [unidad]="unidad"></unidad-evento>
    </ng-container>
</div>